import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {AddEmployee} from './AddEmployees';
import {ViewEmployee} from './ViewEmployee';
import {Routes} from 'navigation/Routes';
import {ScreenWithLayout} from 'components/common/screen-layouts';
import {EmployeeDetails} from './ViewEmployeeDetails';
import {UpdateEmployeeDetails} from './UpdateEmployeeDetails';

const EmployeeStack = createNativeStackNavigator();

export function EmployeeScreen() {
  return (
    <EmployeeStack.Navigator screenOptions={{headerShown: false}}>
      <EmployeeStack.Screen name={Routes.VIEWEMPLOYEE}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <ViewEmployee {...screenProps} />
          </ScreenWithLayout>
        )}
      </EmployeeStack.Screen>
      <EmployeeStack.Screen name={Routes.ADDEMPLOYEE}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <AddEmployee {...screenProps} />
          </ScreenWithLayout>
        )}
      </EmployeeStack.Screen>
      <EmployeeStack.Screen name={Routes.VIEW_EMPLOYEE_DETAILS}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <EmployeeDetails {...screenProps} />
          </ScreenWithLayout>
        )}
      </EmployeeStack.Screen>
      <EmployeeStack.Screen name={Routes.UPDATE_EMPLOYEE_DETAILS}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <UpdateEmployeeDetails {...screenProps} />
          </ScreenWithLayout>
        )}
      </EmployeeStack.Screen>
    </EmployeeStack.Navigator>
  );
}
